export enum ChunksMergeRequestStatus {
  Waiting = 'waiting',
  Merging = 'merging',
  Merged = 'merged',
  Failed = 'failed',
  LiveReportInProgress = 'liveReportInProgress',
}
